import {
  UNIT_ABBREVIATIONS
} from "./chunk-TUPOJF2A.jsx";
import {
  __name
} from "./chunk-DVUTYNGK.jsx";

// src/utils/number/number.ts
var toFixedWithPrecision = /* @__PURE__ */ __name((num, precision) => {
  const precisionExp = 10 ** precision;
  return Math.trunc(Math.floor(num * precisionExp)) / precisionExp;
}, "toFixedWithPrecision");
var shortenNumberToUnits = /* @__PURE__ */ __name((num = 0) => {
  if (num < 1e3) return num.toString();
  let truncatedNumber = "";
  for (let i = UNIT_ABBREVIATIONS.length - 1; i >= 0; i--) {
    const truncationSize = 10 ** ((i + 1) * 3);
    if (num >= truncationSize) {
      truncatedNumber = Number(
        toFixedWithPrecision(num / truncationSize, 1)
      ).toLocaleString() + UNIT_ABBREVIATIONS[i];
      break;
    }
  }
  return truncatedNumber.toString();
}, "shortenNumberToUnits");
function roundOffTo(num, roundingFactor) {
  return Math.round(num / roundingFactor) * roundingFactor;
}
__name(roundOffTo, "roundOffTo");

export {
  shortenNumberToUnits,
  roundOffTo
};
